import { ProductFlags } from '../@types';

export const hasCasinoOnlyProducts = (products?: ProductFlags) => Boolean(products?.casino && !products?.sportsbook);
export const hasSportsbookOnlyProducts = (products?: ProductFlags) =>
  Boolean(products?.sportsbook && !products?.casino);
